import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import RecruitmentRoutes from "../../Employee/Recruitment/RecruitmentLayout/Routes/RecruitmentRoutes";
import Navbar from "../Pages/Landing/Navbar";
import Hero from "../Pages/Landing/Hero";
import Features from "../Pages/Landing/Features";
import Footer from "../Pages/Landing/Footer";
import { useNavigate, Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { clearAuthCookies , isTokenValid} from "../../Utils/authUtils";

const AuthRoute = () => {

  if (isTokenValid()) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="min-h-screen bg-soft text-text">
      <Navbar />
      <main>
        <Hero />
        <Features />
      </main>
      <Footer />
    </div>
  );
};

export default AuthRoute;
